import React from 'react'

export default function Loader() {
    return (
        <div className="spinner">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
        </div>

    )
}
